<template>
  <div class="page-wrap DeviceList-page" ref="container">
		<Search :label="searchLabel" @search="search" ref="search"></Search>
		<List title="绑定设备列表" :refresh="true" :label="label" apiName="petDeviceList" ref="list"></List>
  </div>
</template>
<script>
import Search from "@components/Search";
import List from "@components/List";

export default {
  name: "PetAdminDeviceList",
  components: {
		Search,
		List,
  },
  props: {},
  data: function() {
    return {
      filter: {
      },
			searchLabel : [
				{field : 'machineCode', title : '设备编码'},
				// {field : 'search', title : '渠道名称'},
			],
			label : [
				{field : 'snCode', title : '设备编码'},
				{field : 'addressStr', title : '设备地址'},
				{field : 'statusStr', title : '设备状态', type : "status"},
				{field : 'btn', title : '查看更多', type : 'btn', click: this.moreInfo}
			],
    };
  },
  watch: {
    $route(n) {
      if (n.name === 'PetAdminDeviceList') {
				let prevPage = this.$prevRoute();
				if (prevPage && prevPage.name == "PetAdmin") {
					this.$refs.search.reSet();
					this.filter = {};
					this.search(this.filter);
				}
      }
    }
  },
	created() {},
  mounted: function() {
  },
  computed: {},
  methods: {
		search(filter) {
			this.filter = filter;
			this.$refs.list.reload(filter);
		},
		reload() {
			
		},
		moreInfo(data) {
			this.$router.push({ path: "/petAdmin/deviceInfo/" + data.snCode });
		}
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.page-wrap {
	padding: 0.3rem;
}
</style>
